import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';
import { helveticaBold } from '../../theme-constants/typograhy-overrides';


export const alertStyles = makeStyles((theme) => ({
    alertContainer: {
        display: 'flex',
        alignItems: 'start',
        padding: theme.spacing(1),
        '& .alert': {
            '&-icon': {
                height: '1.25rem',
                width: '1.25rem',
                marginRight: theme.spacing(1),
            },
            '&-content': {
                marginRight: theme.spacing(1.5),
            },
            '&-link-button': {
                background: 'transparent',
                padding: '0',
                border: 'none',
                fontFamily: helveticaBold,
                textDecoration: 'underline',
            },
        },

        '&.warning-alert': {
            background: tcsmColors.yellow,
        },

        '& .button-close': {
            marginLeft: theme.spacing(1),
        },
    },

}));



